<template>
  <div class="content">

    <settings-menu></settings-menu>
    <div class="settings-body settings-website-tab">
      <div class="settings-body-inner">

        <div class="row">
          <div class="col-md-12">
            <div class="s-block">
              <div class="s-block-header">Integrations API Key</div>
              <div class="s-block-body" style="min-height: 132px">
                <div class="website-img-wrap">
                  <img :src="require('../../assets/images/3.png')" alt="">
                </div>
                <div class="website-code-wrap">
                  <div class="form-item">
                    <label><strong>Your API Key:</strong></label>
                    <p>Below is your organization’s API key to use for integrations</p>
                    <p>This code is used to connect your Harness account to other applications via
                      <a href="https://harnessgiving.com/integrations/index" target="_blank">Integrations</a></p>
                  </div>
                  <div v-if="secret" class="form-item">
                    <div class="input-group input-group-right">
                      <input type="text"
                             class="form-control"
                             ref="apiKey"
                             v-model="secret.key"
                             v-on:keydown.prevent=""
                             @focus="copyCode"
                      >
                      <a href="#" v-on:click.prevent="copyCode"
                         class="input-group-addon input-group-addon input-group-btn btn">Copy</a>
                    </div>
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="s-block">
              <div class="s-block-header">Double the Donation - Employer Matching</div>
              <div class="s-block-body" style="min-height: 132px">
                  <div class="form-item">
                    <label><strong>Double the Donation API Key</strong></label>
                    <p>Please add your Double the Donation Key below and click Save</p>
                    <p>You can find this API Key in your Double the Donation Dashboard on the page 
                      <a href="https://doublethedonation.com/members/#/setup/api-keys" target="_blank">Settings > API Keys</a></p>
                  </div>
                  <div class="form-item mb-5">
                    <div class="flex gap-5">
                      <input type="text"
                             class="form-control inline-block"
                             placeholder="Public Key"
                             v-model="employerMatchingPublicKey"
                      >
                      <input :type="privateKeyType"
                             class="form-control inline-block"
                             placeholder="Private Key"
                             v-model="employerMatchingPrivateKey"
                             @focus="clearPrivateKey()"
                      >
                      <button :disabled="!this.privateKeyFieldFocused"  v-on:click.prevent="saveDoubleDonationKey"
                         class="btn px-5">Save</button>
                    </div>
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SettingsMenu from './menu.vue';
  import {getSecretApiKey, EmployerMatchingConfig} from '@/utils/api';
  import {mapState} from "vuex";

  export default {
    name: 'Integrations',
    metaInfo: {
      title: 'Settings - Integrations',
    },
    components: {
      SettingsMenu,
    },
    mounted() {
      Promise.all([
        this.upIntegrations(),
        this.getEmployerMatchingIntegration()
      ]);
      
    },
    methods: {
      upIntegrations() {
        getSecretApiKey().then(secret => this.secret = secret.secret);
      },
      getEmployerMatchingIntegration() {
        EmployerMatchingConfig.get().then(result =>{
          if(result.employerMatching.publicKey) {
            this.employerMatchingPublicKey = result.employerMatching.publicKey
            this.employerMatchingPrivateKey = '1234567891234567'
            this.privateKeyFieldFocused = false
          }
        })
      },
      saveDoubleDonationKey() {
        EmployerMatchingConfig.update(this.employerMatchingPublicKey, this.employerMatchingPrivateKey).then(() => {
          this.employerMatchingPrivateKey = null;
          this.employerMatchingPublicKey = null;
          this.$message('Employer Matching API Keys Saved');
          this.getEmployerMatchingIntegration()
        })
      },
      clearPrivateKey() {
        if(!this.privateKeyFieldFocused) {
          this.employerMatchingPrivateKey = null
          this.privateKeyFieldFocused = true
        }
      },
      copyCode() {
        this.$refs.apiKey.select();
        document.execCommand('copy');

        this.$message('Copied to clipboard!');
      },
    },
    computed: {
      ...mapState({
        activeCharityId: state => state.auth.activeCharityId,
      }),
      privateKeyType() {
        let result = 'text';
        if(this.employerMatchingPublicKey && !this.privateKeyFieldFocused) {
          result = 'password'
        }
        return result
      },
    },
    watch: {
      'activeCharityId' () {
        this.upIntegrations();
      },
    },
    data() {
      return {
        secret: null,
        employerMatchingPublicKey: null,
        employerMatchingPrivateKey: null,
        privateKeyFieldFocused: false,
      };
    },

  };
</script>
<style lang="sass">
  .copied-block
    border-radius: 50px
    padding: 10px 20px
    margin: 16px
    min-width: 100px
</style>
